import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { injectIntl, FormattedMessage } from 'react-intl'

import Loader from '@/checkout-instore-legacy/components/Commons/Loader'

import DeviceCard from './DeviceCard'

import {
  BROADCAST_DEVICE_CONFIGURATION,
  IP_DEVICE_CONFIGURATION,
} from '../constants'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'

class DeviceSummary extends React.Component {
  handleEditClick() {
    this.props.router.push('configure-device')
  }

  createDeviceConfigCard() {
    const { defaultPrinter, deviceName } = this.props.device || {}
    return (
      <DeviceCard
        deviceName={deviceName || '-'}
        defaultPrinter={defaultPrinter || {}}
        configType={BROADCAST_DEVICE_CONFIGURATION}
        onEditClick={() => this.handleEditClick()}
      />
    )
  }

  createIPConfigCard() {
    const { orderPlacedHook } = getInstoreConfig()
    const { url: deviceName } = orderPlacedHook || {}
    return (
      <DeviceCard
        deviceName={deviceName || '-'}
        configType={IP_DEVICE_CONFIGURATION}
        onEditClick={() => this.handleEditClick()}
      />
    )
  }

  render() {
    const { printingConfig } = getInstoreConfig()
    const loading = !this.props.device

    const shouldShowDeviceConfigCard =
      printingConfig && printingConfig.printByBroker

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <div className="flex-collumn self-center">
          <div className="tc mb7">
            <div className="flex justify-center">
              <div className="f2 tc fw7 tc pt6 pb0">
                <FormattedMessage id="configureDeviceTitle" />
              </div>
            </div>
          </div>
          <div className="center pt5" style={{ minWidth: '350px' }}>
            {shouldShowDeviceConfigCard
              ? this.createDeviceConfigCard()
              : this.createIPConfigCard()}
          </div>
        </div>
      </React.Fragment>
    )
  }
}

DeviceSummary.propTypes = {
  router: PropTypes.any,
  device: PropTypes.shape({
    deviceName: PropTypes.string,
    defaultPrinter: PropTypes.object,
  }),
}

export default withRouter(injectIntl(DeviceSummary))
